import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ItemService } from '../../services/item/item.service';
import { LoginService } from "../../services/login/login.service";
import { TokenControlService } from "../../services/state/tokenControl.service";
import { AnswerControlService } from '../../services/answer/answerControl.service';
import { EncryptionService } from "../../services/data/encryption.service";
import { Token } from "../../model/token";
import { DeleteService } from "../../services/data/delete.service";
import { RestService } from '../../services/rest/rest.service';
import { StateService } from "../../services/state/state.service";
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationService } from '../../services/configuration/configuration.service';
import { ConfigurationControlService } from "../../services/configuration/configurationControl.service";
import { FileDTO } from "../../model/file";
import * as CryptoJS from "crypto-js";

import * as ExcelJS from "exceljs/dist/exceljs.min.js";
import * as fs from 'file-saver';
import { HistoricoCargue } from '../../model/historicoCargue';
import { formatDate } from '@angular/common';

declare var require: any;
var crypto = require("crypto-js");

//Variable del global scope para utilizar jquery
declare var $: any;

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.css'],
  providers: [ItemService, RestService, EncryptionService]
})//Controlador de la pagina upload.file.html se encarga de subir los archivos de respuestas
export class UploadComponent implements OnInit {

  public files: any;

  public success: number;
  public error: number;
  public contenidoEncriptado: String;
  public alreadyLoaded: number;
  public loading: boolean;
  public totalArchivosCargar: number;
  public showResume: Boolean;
  public erroresCargue: Array<[string, string]>;
  public mostrarMensaje: boolean;
  esArchivoInvalido: boolean = false;
  public nameFileLoaded: String;
  public statusFileLoaded: String;
  public dataUpload = new Array<HistoricoCargue>();
  //Constructor de la clase
  constructor(
    private _restService: RestService,
    private _tokenController: TokenControlService,
    private _stateService: StateService,
    private _router: Router,
    private _translateService: TranslateService,
    private _configurationService: ConfigurationService,
    private _configurationControlService: ConfigurationControlService,
    private _encryptionService: EncryptionService
  ) {
    this._translateService.addLangs(["es", "en"]);
    this._translateService.setDefaultLang(_configurationControlService.examConfiguration.language);
    this._translateService.use(_configurationControlService.examConfiguration.language);

    this.loading = false;
    this.showResume = false;
    this.mostrarMensaje = false;

  }

  //Necesario debido a implementacion de interfaz OnInit
  //Metodo que se ejecuta al iniciar esta vista
  ngOnInit() {
    this._configurationService.inhabilitarBotonAtras();
    let self = this;
  }

  //Se encarga de redirigir a la pagina de login
  public aceptar() {
    window.location.reload();
    this._router.navigate(['/']);
  }

  public loadFiles(event: any) {
    var files = event.target.files;
  }


  public async cargarArchivo(numarchivo: number, file: any): Promise<string> {
    const self = this;

    return new Promise((resolve) => {
      const fr = new FileReader();

      fr.onload = async (e) => {
        const result = fr.result;

        if (typeof result !== 'string') {
          self.error += 1;
          self.erroresCargue.push([file.name, "Error: formato de archivo no reconocido."]);
          resolve("error");
          return;
        }

        try {
          const text = result;
          const arrayFilas = text.split("_VVVVV_");
          const vector = arrayFilas[0];
          const llave = arrayFilas[1];
          const contenidoEncrip = String(arrayFilas[2]);

          if (!vector || !llave || !contenidoEncrip) {
            self.error += 1;
            self.erroresCargue.push([file.name, "Formato de archivo inválido."]);
            resolve("error");
            return;
          }

          const vector1: any = JSON.parse("[" + vector + "]");

          // Importar la clave
          const key = await window.crypto.subtle.importKey(
            "jwk",
            {
              kty: "oct",
              k: llave.toString(),
              alg: "A128CBC",
              ext: true,
            },
            "AES-CBC",
            true,
            ["encrypt", "decrypt"]
          );

          // Desencriptar el contenido
          const resultDecrypted = await self._encryptionService.decrypt_data_File(
            contenidoEncrip,
            Uint8Array.from(vector1),
            key
          );

          const fileName = file.name;
          const fileDTO = new FileDTO(file.name, resultDecrypted, text);

          // Subir archivo al backend
          const res: any = await self._restService.uploadFileDTO(
            self._tokenController.token.token,
            fileDTO,
            self._tokenController.token.tokenId
          );

          switch (res) {
            case "0":
              self.erroresCargue.push([fileName, "Error al cargar el archivo."]);
              self.error += 1;
              break;
            case "1":
              self.success += 1;
              break;
            case "2":
              self.erroresCargue.push([fileName, "Ya existe el archivo."]);
              self.error += 1;
              break;
          }

          resolve(res);
        } catch (err) {
          console.error("Error procesando archivo:", err);
          self.error += 1;
          self.erroresCargue.push([file.name, "Error al procesar archivo."]);
          resolve("error");
        }
      };

      fr.readAsText(file, 'ISO-8859-4');
    });
  }


  public async leeArchivos() {
    this.mostrarMensaje = false;
    if (this.files == null || this.files.length <= 0) {
      this.mostrarMensaje = true;
      return;
    }
    this.loading = true;
    this.success = 0;
    this.error = 0;
    this.alreadyLoaded = 0;
    var len = this.files.length;
    this.totalArchivosCargar = len;
    let self = this;
    this.erroresCargue = [];
    this.dataUpload = new Array<HistoricoCargue>();

    for (var i = 0; i < len; i++) {

      let dataArchivo = new HistoricoCargue();
      let estado = "";
      dataArchivo.nombre = this.files[i].name;
      dataArchivo.credencial = (this.files[i].name.substring(0, (this.files[i].name.indexOf('_')))).toUpperCase();
      this.nameFileLoaded = this.files[i].name;

      this.statusFileLoaded = '  ( ' + (i + 1) + ' de ' + len + ' )';

      if (this.files[i].name.endsWith(".plx")) {
        await this.cargarArchivo(i, this.files[i]).then(res => {
          console.log(i + " = " + self.files.length);
          this.erroresCargue.forEach((row: any) => {
            if (row[0] === this.files[i].name) {
              estado = row[1];
            }
          })
          if (estado == "") {
            estado = "Archivo cargado sin errores."
          }
        }).catch(err => {
          self.error += 1;
          this.erroresCargue.push([this.files[i].name, "Error al cargar el archivo."])
          estado = "Error al cargar el archivo.";
        })
      } else {
        self.error += 1;
        this.erroresCargue.push([this.files[i].name, "Tipo de archivo no válido."])
        estado = "Tipo de archivo no válido.";
      }

      dataArchivo.fecha = new Date();
      dataArchivo.usuario = (self._tokenController.token.tokenId).toUpperCase();
      dataArchivo.estado = estado.toUpperCase();
      this.dataUpload.push(dataArchivo);
    }

    this.showResume = true;
    this.loading = false;
    this.files = null;
    this.nameFileLoaded = null;
    this.statusFileLoaded = null;

    self._restService.uploadHistoricoCargue(self._tokenController.token.token, this.dataUpload, self._tokenController.token.tokenId).then(
      (res: any) => {
        console.log(res);
      }
    ).catch(err => {
      console.log("Error al registrar el historico de cargue offline: " + err);
    })
  }

  public onFileSelect(input: HTMLInputElement) {
    this.files = input.files;
    this.esArchivoInvalido = Array.from(this.files).some((archivo: any) => archivo.name.split('.').pop() != 'plx');
    if (this.esArchivoInvalido) {
      (this.files = undefined);
      $("#inputFile").val('');
    }
  }

  //Se encarga de redirigir a la pagina de login
  public reset() {
    this.showResume = false;
    this.loading = false;
    this.files = null;
    this.dataUpload = new Array<HistoricoCargue>();
  }

  public descargarResumen() {

    let title = 'PLEXI - Sincronización de archivos offline';
    let dataForExcel = [];

    let headers = ["Nombre Archivo", "Credencial", "Fecha y hora de Cargue", "Estado cargue", "Usuario"];

    this.dataUpload.forEach((row: any) => {
      dataForExcel.push(Object.values(row))
    })
    let workbook = new ExcelJS.Workbook();
    let worksheet = workbook.addWorksheet('Resumen del proceso');

    //Add Row and formatting
    worksheet.mergeCells('A1', 'E2');
    let titleRow = worksheet.getCell('A1');
    titleRow.value = title
    titleRow.font = {
      name: 'Calibri',
      size: 14,
      //underline: 'single',
      bold: true,
      color: { argb: '337ab7' }
    }
    titleRow.alignment = { vertical: 'middle', horizontal: 'center' }

    //Blank Row
    worksheet.addRow([]);

    //Adding Header Row
    let headerRow = worksheet.addRow(headers);

    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '004F87' },
        bgColor: { argb: '' }
      }
      cell.font = {
        bold: true,
        color: { argb: 'FFFFFF' },
        size: 12
      }
    })

    // Adding Data with Conditional Formatting
    dataForExcel.forEach(d => {
      d[2] = formatDate(d[2], 'dd/MM/yyyy h:mm a', 'en_US');
      worksheet.addRow(d);
    }
    );

    worksheet.addRow([]);

    //Footer Row
    let d = formatDate(new Date(), 'dd/MM/yyyy h:mm a', 'en_US');
    let footerRow = worksheet.addRow(['Reporte generado el día: ' + d]);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'fcf8e3' }
    };

    footerRow.getCell(1).font = {
      bold: true,
      color: { argb: '8a6d3b' },
      size: 10
    };

    worksheet.columns.forEach(function (column, i) {
      var maxLength = 0;
      column["eachCell"]({ includeEmpty: true }, function (cell) {
        var columnLength = cell.value ? cell.value.toString().length : 10;
        if (columnLength > maxLength) {
          maxLength = columnLength;
        }
      });
      column.width = maxLength < 10 ? 10 : maxLength;
    });

    //Merge Cells
    worksheet.mergeCells(`A${footerRow.number}:E${footerRow.number}`);

    //Generate & Save Excel File
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, title + '.xlsx');
    })
  }
}
